import Image from 'app/Components/Shared/Image/image';
import React ,{ useState, useEffect, useRef } from 'react';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../Config';
import ButtonElement from './ButtonElement';
import PopUp from 'app/Components/Shared/Popup/PopUp';
import { buildUrlAndNavigate,parseStyleString , navigateTo } from 'app/utilities/StringHelpers/StringHelpers';
import { CloseIcon } from './icons/close';
import { FontSizeByIndex } from './constant';
import { isMobile } from 'react-device-detect';
import DOMPurify from "dompurify";

const BannerCarouselMain = (props) => {
  const items = props.iContent.bannerCarouselElements.value;
  const [popupData, setPopupData] = useState(null);
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);
  const [isMobileMode, setIsMobileMode] = useState(window.innerWidth < 1280);
  const carouselRef = useRef(null)
  const moreServicesLink = props.iContent.moreServices.value?.url;

  var centeringContainerClass = '';
  const itemsWidth = 330 * items.length;
    const windowWidth = window.innerWidth;
    const itemsCanFit = itemsWidth < windowWidth;
     centeringContainerClass = (!isMobileMode && items.length < 6 && itemsCanFit) ? 'centering-container' : '';
  

  const updateButtonStates = () => {
    const container = carouselRef.current;
    if (container) {
        const { scrollLeft, scrollWidth, clientWidth } = container;
        const style = window.getComputedStyle(container);
        const totalHorizontalPadding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
        const maxScroll = scrollWidth - clientWidth;
        
        // Use a small threshold to account for sub-pixel rendering
        const threshold = 5;
        var scrollLeftValue = Math.abs(scrollLeft);
        
        const isAtRightEdge = scrollLeftValue <= threshold;
        setCanScrollPrev(!isAtRightEdge);
        
        const isAtLeftEdge = (maxScroll - scrollLeftValue) <= threshold;
        setCanScrollNext(!isAtLeftEdge);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileMode(window.innerWidth < 1280);
      updateButtonStates();
    };

    const container = carouselRef.current;
    if (container) {
      updateButtonStates();
      
      const resizeObserver = new ResizeObserver(() => {
        updateButtonStates();
      });
      resizeObserver.observe(container);

      container.addEventListener('scroll', updateButtonStates);
      window.addEventListener('resize', handleResize);
      
      // Initial checks after some delays to handle late layout shifts/font loading
      const timer1 = setTimeout(updateButtonStates, 100);
      const timer2 = setTimeout(updateButtonStates, 500);

      return () => {
        resizeObserver.disconnect();
        container.removeEventListener('scroll', updateButtonStates);
        window.removeEventListener('resize', handleResize);
        clearTimeout(timer1);
        clearTimeout(timer2);
      };
    }
  }, [items]);

  const handleNext = () => {
    const container = carouselRef.current;
    if (container) {
      const isRTL = getComputedStyle(container).direction === 'rtl';
      const scrollAmount = isRTL ? -container.clientWidth : container.clientWidth;
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  const handlePrev = () => {
    const container = carouselRef.current;
    if (container) {
      const isRTL = getComputedStyle(container).direction === 'rtl';
      const scrollAmount = isRTL ? container.clientWidth : -container.clientWidth;
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };


  // const getTextElements = (textElements , isPopup = false) => {
  //   return  textElements.map((textElement, textIndex) => (
  //     <p
  //       key={textIndex}
  //       style={{ color: textElement.color , fontSize: getFontSize( textIndex, isPopup,textElements.length) , fontWeight: getFontWeight(textIndex) }}
  //     >
  //       {textElement.text}
  //     </p>
  //   ));
  // }


  const getTextElements = (textElements, isPopup = false) => {
    return textElements.map((textElement, textIndex) => {
      const cleanHTML = DOMPurify.sanitize(textElement.text, { ADD_ATTR: ['style'] });
  
      // Extract existing inline style from the HTML if it starts with <p style="...">
      let mergedStyle = {
        textAlign:( textElement.text_align) ? 'right' : 'center',
        color: textElement.color,
        fontSize: getFontSize(textIndex, isPopup, textElements.length),
        fontWeight: getFontWeight(textIndex ,textElements.length),
      };
  
      const div = document.createElement('div');
      div.innerHTML = cleanHTML;
      const firstChild = div.firstChild;
  
      if (firstChild && firstChild.style) {
        const inlineStyle = parseStyleString(firstChild.getAttribute('style'));
        mergedStyle = { ...inlineStyle, ...mergedStyle }; // your styles override existing ones if conflicts
      }
  
      return (
        <p
          key={textIndex}
          style={mergedStyle}
          dangerouslySetInnerHTML={{ __html: cleanHTML }}
        />
      );
    });
  };

  const getFontSize = ( index, isPopup,textElementsLength ) => {
      
   var fontSize = FontSizeByIndex[isPopup ? 'popup' : 'notPopup'][isMobile ? 'mobile' : 'desktop'];
    if(textElementsLength > 1) {
      return fontSize[index>0 ? 1 : 0];
    }else{
      return fontSize[2];
    }
  }
  const getFontWeight = (index, textElementsLength) =>
   (textElementsLength > 1 && index === 0) ? 600 : 400;
  
  
  const getButtonStyle = (buttonTextElement) => {
    const hasBackgroundColor = !!buttonTextElement?.backgroundColor;
    const bgValue = (buttonTextElement?.backgroundColor || '').trim();
    const isGradientBackground =
      !!bgValue &&
      /(gradient\()|(^\s*(linear-gradient|radial-gradient|conic-gradient)\s*\()|gradient/i.test(bgValue);

    return {
      color: buttonTextElement?.color ? buttonTextElement?.color : '#000000',
      ...(hasBackgroundColor
        ? (isGradientBackground ? { background: bgValue } : { backgroundColor: bgValue })
        : { background: ' linear-gradient(272deg, var(--theme-primary-grad, #BC32CE) -3.43%, var(--theme-primary, #810EA9) 91.44%)' }
      )
    };
  }


  const getImageProps = (item,isPopupImg=false) => {
     var imgUrl = null;
    if(isPopupImg) {
        imgUrl =  isMobileMode ? popupData?.popupMobileBackgroundUrl : popupData?.popupDesktopBackgroundUrl;
      }else{
        imgUrl =  isMobileMode ? item.mobileBackgroundUrl : item.desktopBackgroundUrl;
      }
      if(!imgUrl) { 
        return null;
      }
     return Config.epiBaseUrl + imgUrl;
  }

  const navigateToPage = (pageReference) => {
    if (pageReference) {
      window.location.href = pageReference.url;
    }
  }


  const getPopupHeight = (item) => {
    const hasImage = !!getImageProps(item, true);
    const hasButton = item.text && item.pageReferenceUrl;
    
    if (isMobileMode){
      if  (hasImage) {
        return 450;
      }
      return 'max-content';
    }else{
      if (hasImage) {
        if (hasButton) {
          return 580;
        }
        return 500;

      }
      return 'max-content';
    }
  };
  
  return (
    <div className={`banner-carousel-container ${centeringContainerClass}`}>
      <p className="title">{props.iContent.first_title.value}</p>
      <p className="description">{props.iContent.second_title.value}</p>
      <div className={`banner-carousel-wrapper ${items.length === 1 ? 'single-item' : ''}`} ref={carouselRef}>
        {items.map((item, index) => {
          const imgUrl = getImageProps(item);
          item ={...item , type: props.iContent.carouselType.value}
          return (
            <div
              className="banner-carousel-item"
              key={index}
              style={{ backgroundImage: `url(${imgUrl})` }}
            >
               {<div className="text-elements">
                   {getTextElements(item.textElements)}
                  <ButtonElement item={{...item}} setPopupData={setPopupData} />
              </div>}
            </div>
          );
        })}
      </div>   
      {(!isMobileMode && (canScrollPrev || canScrollNext)) && (
        <div className="banner-carousel-arrow-btns">
          <button
            type="button"
            className={`arrow-btn ${!canScrollPrev ? 'disabled' : ''}`}
            onClick={handlePrev}
            disabled={!canScrollPrev}
            aria-label="previous banner"
          >
            <Image src={require("./icons/CarouselArrowRight.svg")} alt="previous banner" />
          </button>
          <button
            type="button"
            className={`arrow-btn ${ !canScrollNext ? 'disabled' : ''}`}
            onClick={handleNext}
            disabled={!canScrollNext}
            aria-label="next banner"
          >
            <Image src={require("./icons/CarouselArrowLeft.svg")} alt="next banner" />
          </button>
        </div>
      )}
    {popupData && (
        <PopUp
          showPopUp={true}
          onClose={() => setPopupData(null)} 
          style={{ backgroundImage: `url(${getImageProps(popupData,true)})` , minHeight:  getPopupHeight(popupData)
          }}
        >
          <div className="close-btn-popup" onClick={() => setPopupData(null)}>
            <CloseIcon color={popupData?.textElementsPopup?.[0]?.color}  />
          </div>

          {getTextElements(popupData.textElementsPopup , true)}
          {(popupData.text && popupData.pageReferenceUrl) && (
          <button className="join_btn" 
              style={getButtonStyle(popupData)}
              onClick={() => navigateTo(popupData.pageReferenceUrl)}>
                {popupData.text}
          </button>
          )}
        </PopUp>
      )}
      {moreServicesLink && (
        <div className="more-services-link" onClick={() => navigateTo(moreServicesLink)}>
          לשירותים נוספים
        </div>
      )}
    </div>

  ); 
};

export default BannerCarouselMain;